<template>
  <div class="my-bets">
    <div class="my-bets__nav">
      <button class="my-bets__back" @click="$emit('back')"></button>
      <h1>我的竞猜</h1>
      <button class="my-bets__rules" @click="$emit('rules')">规则&好礼</button>
    </div>

    <div v-if="state === 'loading'" class="my-bets__state">加载中...</div>
    <div v-else-if="state === 'error'" class="my-bets__state">
      加载失败 <button @click="load">重试</button>
    </div>
    <div v-else-if="!list.length" class="my-bets__state">暂无参与记录</div>
    <div v-else class="my-bets__list">
      <div v-for="match in list" :key="match.match_key" class="my-bets__item">
        <div class="my-bets__main">
          <div class="my-bets__match">{{ matchTitle(match) }}</div>
          <div class="my-bets__pick">我猜 {{ chosenTeam(match) }}胜</div>
        </div>
        <div class="my-bets__side">
          <div class="my-bets__status" :class="betStatusClass(match)">{{ betStatus(match) }}</div>
          <div class="my-bets__ticket">门票{{ ticketCoin(match) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyBets } from '@/api/worldcupQuiz'
import { roundLabel, SIDE_B, unwrapResponse } from '../utils'

export default {
  name: 'WorldCupQuizMyBets',
  data () {
    return {
      state: 'loading',
      list: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.state = 'loading'
      try {
        this.list = unwrapResponse(await this.getMyBetsWithRetry()) || []
        this.state = 'success'
      } catch (error) {
        if (this.isNetworkLikeError(error)) {
          this.list = []
          this.state = 'success'
          return
        }
        this.state = 'error'
      }
    },
    async getMyBetsWithRetry () {
      const options = {
        skipToast: true,
        skipToastOnStatus0: true
      }
      try {
        return await getMyBets(options)
      } catch (error) {
        if (!this.isNetworkLikeError(error)) throw error
        await new Promise(resolve => window.setTimeout(resolve, 300))
        return getMyBets(options)
      }
    },
    isNetworkLikeError (error) {
      if (!error) return false
      return error.message === 'Network Error' ||
        error.code === 'ERR_NETWORK' ||
        (error.request && error.request.status === 0)
    },
    matchTitle (match) {
      return `${roundLabel(match)} · ${match.team_a || '待公布'} vs ${match.team_b || '待公布'}`
    },
    chosenTeam (match) {
      const bet = match && match.my_bet
      if (bet && bet.chosen_team) return bet.chosen_team
      if (bet && Number(bet.chosen_side) === SIDE_B) return match.team_b || '客队'
      return match.team_a || '主队'
    },
    betStatus (match) {
      const result = Number(match && match.my_bet && match.my_bet.hit_result)
      if (result === 1) return '已猜中'
      if (result === 2) return '未猜中'
      return '待结算'
    },
    betStatusClass (match) {
      const result = Number(match && match.my_bet && match.my_bet.hit_result)
      if (result === 2) return 'is-lose'
      if (result !== 1) return 'is-pending'
      return ''
    },
    ticketCoin (match) {
      const coin = match && match.my_bet && match.my_bet.ticket_coin
      return coin === undefined || coin === null || coin === '' ? '--' : coin
    }
  }
}
</script>

<style scoped lang="scss">
.my-bets {
  min-height: 100vh;
  padding: 0 16px 128px;
  box-sizing: border-box;
  background: #145720;
  font-family: "PingFang SC", sans-serif;
}

.my-bets__nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(var(--quiz-safe-top, 0px) + var(--quiz-nav-height, 48px));
  padding-top: var(--quiz-safe-top, 0px);
  box-sizing: border-box;
}

.my-bets__nav h1 {
  margin: 0;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.my-bets__back {
  position: absolute;
  left: 0;
  bottom: calc((var(--quiz-nav-height, 48px) - 24px) / 2);
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
}

.my-bets__back:before {
  content: "";
  position: absolute;
  left: 8px;
  top: 5px;
  width: 10px;
  height: 10px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
}

.my-bets__rules {
  position: absolute;
  right: 0;
  bottom: calc((var(--quiz-nav-height, 48px) - 24px) / 2);
  height: 24px;
  padding: 0;
  border: 0;
  color: #fff;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.my-bets__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 14px;
}

.my-bets__item {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
  height: 90px;
  padding: 17px 12px 16px 16px;
  box-sizing: border-box;
  border: 2px solid #ffe744;
  border-radius: 12px;
  background: rgba(10, 55, 18, .72);
}

.my-bets__main {
  flex: 1 1 auto;
  min-width: 0;
}

.my-bets__match {
  width: 100%;
  overflow: hidden;
  color: #ffe744;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-bets__pick {
  margin-top: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.my-bets__side {
  flex: 0 0 auto;
  text-align: right;
}

.my-bets__status {
  color: #ffe744;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
}

.my-bets__status.is-lose {
  color: rgba(255, 255, 255, .6);
  font-weight: 500;
}

.my-bets__status.is-pending {
  color: #fff;
}

.my-bets__ticket {
  margin-top: 17px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.my-bets__state {
  padding: 120px 0;
  color: rgba(255, 255, 255, .72);
  text-align: center;
  font-size: 14px;
}

.my-bets__state button {
  margin-left: 8px;
  border: 0;
  color: #ffe744;
  background: transparent;
  font-weight: 600;
}
</style>
